import { DateTime } from 'luxon';

import {
  ArraySignatures,
  FixMe,
  Project,
} from '@greenkub-fronts/shared/interface';
import { Icon, IconEnum } from '@greenkub-fronts/shared/ui';
import cx from 'classnames';

import styles from './decharge-client.module.scss';

export interface DechargeClientProps {
  project: Project;
  signatures: ArraySignatures;
  lastName: string;
  firstName: string;
  date: DateTime;
  isSignature: boolean;
  signature: string;
  sign1Ref: FixMe;
  handleOpenModalSignHandler: (index: number) => void;
}

const DechargeClient = (props: DechargeClientProps) => {
  const {
    project,
    signatures,
    lastName,
    firstName,
    date,
    isSignature,
    signature,
    sign1Ref,
    handleOpenModalSignHandler,
  } = props;

  return (
    <div className={styles['Doc-container']}>
      <div>
        <div className={styles['Doc-head']}>
          <Icon
            name={IconEnum.LOGO_GREENKUB}
            className={styles['Doc-head-logo']}
          />
          <h1>Contact de décharge client</h1>
        </div>

        <div className={styles['Doc-content']}>
          <p>
            Je soussigné(e) {lastName} {firstName}
          </p>
          <p>
            atteste donner mandat à la société Greenkub SAS immatriculée sous le
            numéro 798 802 377 au registre du commerce et des sociétés de
            Montpellier pour pouvoir effectuer la déclaration préalable de
            travaux ou le permis de construire nécessaire à l'installation de
            ma construction bois ou de mon extension.
          </p>
        </div>

        <div className={styles['Doc-middle']}>
          <div className={styles['Doc-comment']}></div>

          <div className={styles['Doc-signature']}>
            <span>
              Fait à {project.address.city} le {date?.toFormat('dd/MM/yyyy')}
            </span>
            <br />
            <br />
            <span>Signature</span>
            <br />
            {isSignature &&
              (signatures[0] === true ? (
                <p className={styles['Doc-signed']}>{signature}</p>
              ) : (
                <div
                  ref={sign1Ref}
                  className={cx(
                    styles['Doc-signatureBox'],
                    signatures[0] === 'pulse' && styles['pulse']
                  )}
                  onClick={() => {
                    handleOpenModalSignHandler(0);
                  }}
                >
                  <span>Cliquez ici pour signer</span>
                </div>
              ))}
          </div>
        </div>

        <div className={styles['Doc-foot']}>
          <p>
            SAS Greenkub - RCS N° 798802377 au capital de 1 249 731,29 Euros - TVA
            N° FR27798802377
          </p>
          <p>
            300 Avenue de la Royale 34160 Castries - France - Tel&nbsp;: 09 74
            59 41 72
          </p>
        </div>
      </div>
    </div>
  );
};

export default DechargeClient;
